import React from 'react';
import styled from 'styled-components';
import {
  ButtonsContainer,
  IdentifierContainer,
  Title,
  TitleContainer,
  ViewsContainer,
  WindowsContainer,
} from './Identifier.style';
import THEME from '../../../../constants/theme';

interface ButtonProps {
  $isActive?: boolean;
}

export const Button = styled.div.attrs({
  className: 'Button',
})<ButtonProps>(
  ({ $isActive }) => `
    background: ${$isActive ? THEME?.identifier : THEME?.variant8Light};
    color:  #ccc;
    border-radius: 5px;
    height: 32px;
    width: 127px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    cursor: pointer;
    font-size: 12px;
    padding: 5px;
    &:hover {
      background: ${$isActive ? THEME.identifier : '#444'};;
    }
  `
);

interface IdentifierProps {
  dicom: any;
  viewClasses: any[];
  viewLabel: any;
  setViewLabel: (viewLabel: any) => void;
}

const Identifier = ({ dicom, viewClasses, viewLabel, setViewLabel }: IdentifierProps) => {
  const type = dicom?.type;
  const uniqueWindows = Array.from(new Set(viewClasses?.map(viewClass => viewClass?.window)));

  const windowOrders = [
    'Long Axis',
    'Short Axis',
    'Apical',
    'Subcostal',
    'Suprasternal',
    'Miscellaneous',
    'ICE RA Source Chamber',
    'ICE RV Source Chamber',
    'ICE LA Source Chamber',
    'ICE Miscellaneous',
  ];
  const orderedWindows = uniqueWindows.sort((a: any, b: any) => {
    const stringA = a.replace(' Color', '');
    const stringB = b.replace(' Color', '');
    const indexA = windowOrders.indexOf(stringA);
    const indexB = windowOrders.indexOf(stringB);

    return indexA - indexB;
  });

  const buttons = orderedWindows?.map((window: any, windowIndex) => {
    const filteredviewClasses = viewClasses
      ?.filter(viewClass => viewClass?.type === type)
      ?.filter(viewClass => viewClass?.window === window)
      ?.map((viewClass, viewIndex) => {
        const handleViewClassOnClick = () =>
          setViewLabel({
            ...viewLabel,
            dicom: dicom?.uuid,
            viewClass: viewClass?.uuid,
          });

        return (
          <Button
            key={viewIndex}
            onClick={handleViewClassOnClick}
            $isActive={viewLabel?.viewClass === viewClass?.uuid}
          >
            {viewClass.view}
          </Button>
        );
      });

    return (
      <ViewsContainer key={windowIndex}>
        <Title>{window}</Title>
        <ButtonsContainer>{filteredviewClasses}</ButtonsContainer>
      </ViewsContainer>
    );
  });

  return (
    <IdentifierContainer>
      <TitleContainer>Select View</TitleContainer>
      <WindowsContainer>{buttons}</WindowsContainer>
    </IdentifierContainer>
  );
};

export default Identifier;
